export default __webpack_public_path__ + "static/aboutleft-85263aea14294aa52b2723bc1cde0043.jpg";